module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAA9UlEQVRIx2OIsea946VwR0WezogBCLQU2c62yj31VaS3xUDAxcE4v0bi23wVulnPgAzivfi+7lelj/UMaAAY7FeWKvw/rkZr6xkwATDY51VLAO2mqfUMuECcJ9+XfSq0sx5hU0ZGhpiYGJAhLS0tKysLZGgqQIOdFtYjLM7Ozr579+6kSZNu3rzJxsaGGezUtR5qKzc395QpU/6DQU1NDZ5gp5b1IHNFRUXnzZt3/fp1iMWfP3/28PCgh8VwcOvWrfz8fA0NDQcHB2ZmZnoENQR0dXXBY5d+iQsIODg4BiA7DXABMjBF5gBUEgNTLQ5MQ2Cgmj4AlcJJ94zFsScAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/tl.png
// module id = 395
// module chunks = 0